import { render, staticRenderFns } from "./Renovations.vue?vue&type=template&id=6c5cbd08&"
import script from "./Renovations.vue?vue&type=script&lang=js&"
export * from "./Renovations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports